/*eslint-disable*/
import React, { useEffect, useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { mainContext } from "reducer";
import MessageAlert from "components/Alerts/MessageAlert";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
// import Footer from "components/Footers/Footer.js";
import { AsyncComponent } from "asyncComponent.js";

const asyncBurnt = AsyncComponent(() =>
  import(/* webpackChunkName: "Burnt" */ "views/Burnt/index.js")
);


const asyncArticle = AsyncComponent(() =>
  import(/* webpackChunkName: "article" */ "views/Burnt/article.js")
);

export default function Admin() {
  const { dispatch, state } = useContext(mainContext);
  const { theme } = state;

  return (
    <>
      <div
        className={`${
          theme === "light" ? "bg-blueGray-100 " : "bg-dark-body "
        } pb-16 main-bg`}
        style={{ minHeight: "100vh" }}
      >
        <IndexNavbar color={theme} />
        <div className="w-full">
          <Switch>
            <Route path="/nftburnt" exact component={asyncBurnt} />
            <Route path="/whistleblowernotice" exact component={asyncArticle} />
            <Redirect from="/" to="/nftburnt" />
          </Switch>
        </div>
      </div>

      {/* <Footer /> */}
      {/* <LoginModal /> */}
      {/* <MessageModal color={theme} /> */}
      <MessageAlert />
    </>
  );
}
